<div class="cart-item-list">
  @if (hasHeader) {
    <div class="d-none d-md-block d-lg-block d-xl-block">
      <div class="cx-item-list-header row">
        <div class="cx-item-list-desc col-md-5 col-lg-5 col-xl-6">
          {{ 'cartItems.description' | cxTranslate }}
        </div>
        <div class="cx-item-list-price col-md-3 col-lg-2 col-xl-2">
          {{ 'cartItems.itemPrice' | cxTranslate }}
        </div>
        <div class="cx-item-list-qty col-md-2 col-lg-3 col-xl-2">
          {{ 'cartItems.quantity' | cxTranslate }}
        </div>
        @if (options.isSaveForLater) {
          <div class="cx-item-list-total col-md-2 col-lg-2 col-xl-2">
            {{ 'saveForLaterItems.stock' | cxTranslate }}
          </div>
        } @else {
          <div class="cx-item-list-total col-md-2 col-lg-2 col-xl-2">
            {{ 'cartItems.total' | cxTranslate }}
          </div>
        }
      </div>
    </div>
  }

  @for (item of items; track item; let i = $index) {
    <div class="cx-item-list-row">
      @if (getControl(item) | async; as control) {
        <div
          class="cx-item-list-items no-padding"
          [class.is-changed]="control.get('quantity').dirty"
          >
          <app-custom-cart-item-stock
            [item]="item"
            [quantityControl]="control.get('quantity')"
            [readonly]="readonly"
            [promotionLocation]="promotionLocation"
            [options]="options"
            [showStockStatus]="showStockStatus"
          ></app-custom-cart-item-stock>
        </div>
      }
    </div>
  }
</div>
